import { render, staticRenderFns } from "./ShowFees.vue?vue&type=template&id=25f39b19&"
import script from "./ShowFees.vue?vue&type=script&lang=js&"
export * from "./ShowFees.vue?vue&type=script&lang=js&"
import style0 from "./ShowFees.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports